import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import Button from 'components/_atoms/Button'
import CrossCircle from 'components/icons/CrossCircle'
import InfoCircle from 'components/icons/InfoCircle'

import './styles.css'

class EventSummary extends Component {
  static propTypes = {
    event: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    hasPreviousEvent: PropTypes.bool.isRequired,
    hasNextEvent: PropTypes.bool.isRequired,
    goToPreviousEvent: PropTypes.func.isRequired,
    goToNextEvent: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    showEventInfo: PropTypes.func.isRequired,
    backgroundMode: PropTypes.bool.isRequired,
  }

  render() {
    const {
      event,
      hasPreviousEvent,
      hasNextEvent,
      goToPreviousEvent,
      goToNextEvent,
      close,
      showEventInfo,
      backgroundMode,
    } = this.props
    if (backgroundMode) {
      return (
        <div data-component="EventSummary">
          <div className="event-cut-away" />
        </div>
      )
    }
    return (
      <div data-component="EventSummary">
        <a className="close-btn" onClick={close}>
          <CrossCircle customClassName="close-btn-icon" width={40} />
        </a>
        <div className="event-cut-away" />
        <div className="event-details">
          <div className="event-name">
            {event.name}
          </div>
        </div>
        <div className="event-links">
          <a className="event-info-icon" onClick={showEventInfo}>
            <InfoCircle width={40} />
          </a>
          {hasPreviousEvent &&
            <Button
              className="prev-link"
              tabIndex={-3}
              onClick={() => goToPreviousEvent()}
            >
              Prev
            </Button>}
          {hasNextEvent &&
            <Button
              className="next-link"
              tabIndex={-2}
              onClick={() => goToNextEvent()}
            >
              Next
            </Button>}
        </div>
      </div>
    )
  }
}

export default EventSummary



// WEBPACK FOOTER //
// ./src/components/EventSummary/index.js